import { render, staticRenderFns } from "./TheReportDetails.vue?vue&type=template&id=6f083640&"
import script from "./TheReportDetails.vue?vue&type=script&lang=js&"
export * from "./TheReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports